import React from "react";
import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";

const FounderSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 8 },
        bgcolor: "#FFF8E1",
      }}
    >
      <Typography
        variant="h3"
        fontWeight="bold"
        textAlign="center"
        sx={{
          color: "#D35400",
          mb: { xs: 4, md: 6 },
          fontSize: { xs: "1.8rem", md: "2.8rem" },
        }}
      >
        Meet Our Founder
      </Typography>

      <Grid
        container
        spacing={6}
        alignItems="center"
        justifyContent="center"
        direction={isMobile ? "column" : "row"}
      >
        {/* Founder Image */}
        <Grid item xs={12} md={5}>
          <Box
            component="img"
            src="founderImage.png" // 🔁 Replace with your image
            alt="Founder"
            sx={{
              width: "100%",
              height: { xs: 280, md: 400 },
              objectFit: "cover",
              borderRadius: 3,
              boxShadow: 3,
            }}
          />
        </Grid>

        {/* Vision Text */}
        <Grid item xs={12} md={7}>
  <Box
    sx={{
      bgcolor: "white",         // soft yellow background
      borderRadius: 3,
      boxShadow: 2,
      px: { xs: 3, md: 6, lg: 5 },
      py: { xs: 3, md: 5 },
      mx: { xs: 2, md: 40 },
    }}
  >
    <Typography
      sx={{
        fontSize: { xs: "1rem", md: "1.25rem" },
        lineHeight: { xs: 1.6, md: 1.9 },
        color: "#444",
        textAlign: { xs: "center", md: "left" },
        fontWeight: 400,
      }}
    >
      “At <strong>Kulche Shulche</strong>, my vision has always been to bring authentic
      North Indian flavors to every corner of the country. Our goal is
      not just to serve food — but to share joy, nostalgia, and the
      richness of tradition on every plate. I believe food is a story,
      and we’re proud to be telling ours with every kulcha we serve.”
    </Typography>
  </Box>
</Grid>

      </Grid>
    </Box>
  );
};

export default FounderSection;
